export const REQUIRED_TEXT = '*Obligatorio';

export const CREATE_PRAGMAPOWER_FORM_LABELS = {
  name: 'Nombre',
  namePlaceholder: 'Agrega el nombre del pragmapower',
  description: 'Descripción',
  descriptionPlaceholder: 'Agrega la descripción del pragmapower',
  type: 'Tipo',
  typePlaceholder: 'Selecciona un tipo',
  required: 'Completa este campo',
  cancel: 'Cancelar',
};

export enum ExtraDataFormLabel {
  accountName = 'Nombre de la cuenta',
  projectName = 'Nombre del proyecto',
  leaderEmail = 'Correo del manager',
  pragmaticRole = 'Rol del pragmático en la cuenta',
  experienceTime = 'Tiempo total de experiencia en el rol',
}

export enum ExtraDataFormPlaceholder {
  accountName = 'Agrega el nombre de la cuenta',
  projectName = 'Agrega el nombre del proyecto',
  leaderEmail = 'Agrega el correo del manager',
  pragmaticRole = 'Agrega el rol del pragmático en la cuenta',
  experienceTime = 'Agrega el tiempo total de experiencia en el rol',
}

export const PragmaticInformationForm = {
  PLACERHOLDER: 'Selecciona una opcion',
};

export enum SELECTOR_OPTIONS {
  WithoutTechnology = 'Sin tecnología',
  WithoutSpeciality = 'Sin especialidad',
}

export enum EDIT_INFO_FORMULARY_LABELS {
  ChapterLabel = 'Chapter',
  SpecialityLabel = 'Especialidad',
  TechnologyLabel = 'Tecnología',
  SeniorityLabel = 'Seniority',
  LevelLabel = 'Level',
}

export const NO_DATE_TEXT = 'No tiene fecha';

export enum ASSESSMENT_SCHEDULE_LABELS {
  NextAssessmentLabel = 'Fecha sugerida de tu próxima review de crecimiento:',
  CompetenciesUpdateLabel = 'Fecha actualización competencias:',
  NoDateText = 'No tiene fecha',
}

export enum EXTENSION_LABELS {
  StatusBadgeLabel = 'Estado:',
  StatusBadgeText = 'Prórroga',
  BadgeAltText = 'reloj',
  Title = 'Review de crecimiento',
  Description = 'No realizaste tu review de crecimiento a tiempo, se habilitó una nueva fecha para ser realizada.',
  OriginalDateLabel = 'Fecha original:',
  NewDateLabel = 'Nueva fecha:',
  CompetenciesUpdateLabel = 'Fecha actualización competencias:',
  NoDateText = 'No tiene fecha',
}
